import cmnViewMap from '../Index';
import prodViewMap from '../../project/production/Index';
import systemViewMap from '../../system/Index';
import CalWeekSummary from './components/CalWeekSummary';

const calViewMap = {
    "vProdPlanGridSummary": CalWeekSummary,
    ...prodViewMap,
    ...cmnViewMap,
    ...systemViewMap
};

export default calViewMap;
